export default class GridRowElement extends HTMLElement {
  constructor() {
    super();
  }

}
customElements.define('grid-row', GridRowElement);